import './example.scss'

function init() {
    console.log("example.js");
}

export default init


export function example(block) {
    console.log("example", block);
}